import {chain} from 'lodash';
import {useMemo} from 'react';

import {labelToOption, type LogLabelFilterOption} from '../LogLabelFilter';
import {type LogLineData} from '../LogLineRenderer';

/**
 * useLogLabels extracts the set of unique labels from the provided log lines.
 * If all lines are unlabeled, and empty array is returned. Otherwise, all
 * unique labels, including an empty string, are returned.
 */
export function useLogLabels(
  lines: readonly LogLineData[]
): LogLabelFilterOption[] {
  return useMemo(() => {
    // 'lines' is potentially very large, so lazily evaluate this.
    const labels = chain(lines)
      .map(line => line.label)
      .uniq()
      .value();
    if (labels.length === 1 && !labels[0]) {
      // none of the lines are labeled; return empty list
      return [];
    }

    // at least some lines are labeled; sort & return, including empty labels
    return labels.sort().map(labelToOption);
  }, [lines]);
}
